import { connect } from 'react-redux';

import { GlobalState } from 'ha/types/store';
import {
  getMarkers,
  getMapCenter,
  getUniversities,
  isMobileMapOpen,
  getClusters,
  getMapBounds,
} from 'ha/pages/Search/selectors';

import SearchMap from 'ha/pages/Search/components/SearchMap';
import {
  onMapChanged,
  toggleMapAutoSearch,
  updateBounds,
  onPinClick,
  resetMap,
} from '../actions';

export default connect(
  (state: GlobalState) => ({
    mapZoom: state.search.map.zoomLevel,
    highlightedRoomId: state.search.map.highlightedRoomId,
    scrollwheel: state.search.map.scrollwheel,
    markers: getMarkers(state),
    universities: getUniversities(state),
    mapCenter: getMapCenter(state),
    isMobileMapOpen: isMobileMapOpen(state),
    mapBounds: getMapBounds(state),
    clusters: getClusters(state),
  }),
  {
    onMapChanged,
    toggleMapAutoSearch,
    updateBounds,
    onPinClick,
    resetMap,
  },
)(SearchMap);
